import { SVGProps, Ref, forwardRef } from 'react';

export const CarDoorFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.92.503C6.623.51 7.065.54 7.482.665a4 4 0 0 1 .769.318c.51.277.935.702 1.782 1.55l3.436 3.435c.848.847 1.272 1.271 1.549 1.782q.199.367.318.769c.165.557.165 1.156.165 2.355 0 1.834 0 2.75-.432 3.414l-.164.225a2.7 2.7 0 0 1-.616.555l-.128.077c-.654.355-1.567.355-3.286.355H5.833c-2.357 0-3.609 0-4.4-.644l-.152-.137c-.683-.684-.768-1.731-.779-3.667L.5 10.167V5.126c0-1.719 0-2.632.355-3.286l.077-.128c.152-.234.34-.441.555-.616l.225-.164C2.375.5 3.292.5 5.126.5zM3 11.53h4v-1.4H3zM5.126 1.9c-.945 0-1.551.002-2.007.047-.433.043-.577.115-.643.158a1.3 1.3 0 0 0-.37.37c-.044.067-.116.21-.159.644-.045.456-.047 1.062-.047 2.007v2.507h11.242c-.17-.177-.386-.396-.665-.675L9.042 3.522c-.905-.905-1.169-1.15-1.459-1.307a2.6 2.6 0 0 0-.5-.207c-.317-.094-.676-.108-1.957-.108"
                fill="currentColor"
            />
        </g>
    </svg>
));
CarDoorFilledSize16Glyph.displayName = 'CarDoorFilledSize16Glyph';
